import styles from './HeroSection.module.css'

export const Card = ({name, index}) => {
    return (
        <div className={styles.card}>
            <p className={styles.name}>{name}</p>
            <p className={styles.index}>{(index + 1).toString().padStart(2,'0')}</p>
        </div>
    )
}